/* Warning: please do not statically import any dependencies here except for static assets like icons */
import { type Extensions, type ExtensionsConfig } from "@sparky/framework";
import {
	SPARKY_NAV3_HIDDEN_EXTPOINT,
	SPARKY_NAV3_ROUTES_EXTPOINT,
	type SparkyNavRouteConfig,
} from "@sparky/framework/extpoints";

import { EMPTY_OBJECT, MICROAPP_NAME } from "./constants";
import { isAllowed, MODEL_SCANNING, RED_TEAMING } from "./utils/activation";

export const extensions = () => {
	const nav3routeExt = {
		point: SPARKY_NAV3_ROUTES_EXTPOINT,
		configs: [
			{
				id: `${MICROAPP_NAME}.nav.routes.insights.ai-security.red-teaming`,
				config: {
					path: "/insights/ai-security/red-teaming",
					fallbackRedirect: "/insights/ai-security/landing#red_teaming",
					component: () => import("./pages/Simulations"),
					contentClassName: "panwds-tw3",
					mapStateToProps: () => EMPTY_OBJECT,
					isAllowed: () => isAllowed(RED_TEAMING),
				},
			},
			{
				id: `${MICROAPP_NAME}.nav.routes.insights.ai-security.model-scanning`,
				config: {
					path: "/insights/ai-security/model-scanning",
					fallbackRedirect: "/insights/ai-security/landing#model_scanning",
					component: () => import("./pages/Scans"),
					contentClassName: "panwds-tw3",
					mapStateToProps: () => EMPTY_OBJECT,
					isAllowed: () => isAllowed(MODEL_SCANNING),
				},
			},
		],
	} as ExtensionsConfig<SparkyNavRouteConfig>;

	const alwaysOnExt = {
		point: SPARKY_NAV3_HIDDEN_EXTPOINT,
		configs: [
			{
				id: `${MICROAPP_NAME}.nav.routes.insights.ai-security.perpetual-view`,
				config: {
					navComponent: () => import("./pages/UploadSatusAlwaysOn"),
					isAllowed: () => isAllowed(MODEL_SCANNING),
				},
			},
		],
	};

	return [nav3routeExt, alwaysOnExt] as Extensions;
};

export const exposes = {
	default: {
		ModelScanningOnboarding: () => import("@/components/Onboarding/ModelScanningOnboarding"),
		RedTeamingOnboarding: () => import("@/components/Onboarding/RedTeamingOnboarding"),
	},
};

// @TODO: Temporary Nav2 support, remove soon
export default () => ({
	navigation: [
		{
			key: "insights",
			path: "/insights",
			title: "Insights",
			mergeNav: true,
			children: [
				{
					key: `${MICROAPP_NAME}.nav.routes.insights.ai-security.red-teaming`,
					title: "Prisma AIRS - AI Red Teaming",
					contentClassName: "reports-root panwds-tw3",
					expandable: false,
					path: "/insights/ai-security/red-teaming",
					hidden: true,
					noRBACheck: true,
					exact: false,
					callAvail: true,
					mapStateToProps: () => EMPTY_OBJECT,
					component: () => import("./pages/Simulations"),
					avail: () => isAllowed(RED_TEAMING),
				},
				{
					key: `${MICROAPP_NAME}.nav.routes.insights.ai-security.model-scanning`,
					title: "Prisma AIRS - AI Model Scanning",
					contentClassName: "reports-root panwds-tw3",
					expandable: false,
					path: "/insights/ai-security/model-scanning",
					hidden: true,
					noRBACheck: true,
					exact: false,
					callAvail: true,
					mapStateToProps: () => EMPTY_OBJECT,
					component: () => import("./pages/Scans"),
					avail: () => isAllowed(MODEL_SCANNING),
				},
			],
		},
	],
});
